/* eslint-disable */
import PropTypes from 'prop-types';
import filtersActionCreators from '../../State/Store/Filters/Filters.actions';
import ThemeStatePropTypes from '../../State/Store/Theme/Theme.props';
import propsActionCreatorsToPropTypes from '../../Support/Props/ActionCreatorKey/PropsActionCreatorsToPropTypes.support';

const DateNavPropTypes = {
  /**
   * The actions to be used by this component
   */
  actions: PropTypes.shape({
    ...propsActionCreatorsToPropTypes(filtersActionCreators),
  }).isRequired,

  /**
   * The JSS classes to use
   */
  classes: ThemeStatePropTypes.classes.isRequired,

  /**
   * The filters
   */
  filters: PropTypes.object.isRequired,

  /**
   * The callback for any of the date nav actions
   */
  onDateNav: PropTypes.func,

  /**
   * The JSS theme to use
   */
  theme: ThemeStatePropTypes.theme.isRequired,

  /**
   * The screen width
   */
  width: PropTypes.string.isRequired,
};

export default DateNavPropTypes;
